import React from "react";
import dynamic from "next/dynamic";

import useMobile from "../../hooks/useMobile";

const MastheadSearchBC = dynamic(() => import("./Desktop/MastheadSearchBC"));
const SectionNav = dynamic(() => import("../Navbar/Desktop/SectionNav"));
const MobileHeaderBC = dynamic(() => import("./Mobile/MobileHeaderSearchBC"));

const NavbarSearchBC = () => {
  const isMobile = useMobile();

  return isMobile ? (
    <div>
      <MobileHeaderBC />
    </div>
  ) : (
    <div className="z-10 relative bg-white">
      <MastheadSearchBC />
      <SectionNav />
    </div>
  );
};

export default React.memo(NavbarSearchBC);
